var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9973 17.0015C21.3565 17.0015 24.8902 13.4678 24.8902 9.10868C24.8902 4.74957 21.3565 1.21582 16.9973 1.21582C12.6382 1.21582 9.10449 4.74957 9.10449 9.10868C9.10449 13.4678 12.6382 17.0015 16.9973 17.0015Z",
    stroke: "#0000AC",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0074 32.7872C30.9878 29.6079 28.9849 26.8345 26.2876 24.8668C23.5902 22.8991 20.3376 21.8389 16.9988 21.8389C13.66 21.8389 10.4074 22.8991 7.71004 24.8668C5.01266 26.8345 3.0098 29.6079 1.99023 32.7872H32.0074Z",
    stroke: "#0000AC",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassenger);
export default __webpack_public_path__ + "static/media/passenger.989422903f3b15191a06218fd5f3537c.svg";
export { ForwardRef as ReactComponent };